<template>
    <div class="main">
        <div v-loading="carregando">

            <!-- ========================= IDENTIFICAÇÃO ========================= -->
            <c-panel :title="tituloTela" titleIcon="fas fa-file-signature">
                <el-alert v-if="somenteLeitura" :title="'Requisição ' + rotuloStatus + ' — somente leitura.'"
                    type="info" :closable="false" class="u-mb-15"></el-alert>

                <el-form label-position="top" :model="dados" ref="dados">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="10" :md="10">
                            <el-form-item label="Operador">
                                <el-input :value="operador" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="10" :md="10">
                            <el-form-item label="Almoxarifado">
                                <el-input :value="almoxarifado ? almoxarifado.nome : 'Nenhum almoxarifado definido'" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="4" :md="4">
                            <el-form-item label="Nº da Requisição">
                                <el-input :value="numero || '-'" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="20" :md="20">
                            <el-form-item label="Solicitante" prop="instituicao_id" :rules="[$requiredChange]">
                                <!-- Escola só pede para si; a SMED pode abrir por outra. -->
                                <el-select v-if="ehSmed" v-model="dados.instituicao_id" :disabled="somenteLeitura"
                                    filterable placeholder="Selecione" style="width:100%;">
                                    <el-option v-for="i in solicitantes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                                </el-select>
                                <el-input v-else :value="nomeInstituicao" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="4" :md="4">
                            <el-form-item label="Data">
                                <el-date-picker v-model="dados.data_requisicao" :disabled="somenteLeitura" type="date"
                                    format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </c-panel>

            <!-- ============================= ITENS ============================= -->
            <c-panel title="PRODUTOS SOLICITADOS" titleIcon="fas fa-boxes">

                <!-- Linha de inclusão: grupo filtra, o nome do produto busca. -->
                <el-form v-if="!somenteLeitura" label-position="top" @submit.native.prevent>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8" :md="5">
                            <el-form-item label="Grupo">
                                <el-select v-model="linha.grupo_id" filterable clearable placeholder="Todos"
                                    style="width:100%;" @change="trocarGrupo">
                                    <el-option label="Todos" value=""></el-option>
                                    <el-option v-for="g in grupos" :key="g.id" :label="g.nome" :value="g.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="16" :md="13">
                            <el-form-item label="Produto">
                                <el-select v-model="linha.produto_id" filterable remote clearable
                                    :remote-method="buscarProduto" :loading="buscandoProduto"
                                    placeholder="Digite o nome ou o código" style="width:100%;"
                                    @change="selecionarProduto">
                                    <!-- Produto zerado continua na lista, mas não pode ser pedido:
                                         some-lo faria a escola achar que ele não existe. -->
                                    <el-option v-for="p in produtos" :key="p.id" :label="rotuloProduto(p)"
                                        :value="p.id" :disabled="semEstoque(p)">
                                        <span>{{ rotuloProduto(p) }}</span>
                                        <span v-if="semEstoque(p)" class="sem-estoque">Sem estoque</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="10" :sm="6" :md="3">
                            <el-form-item label="Quantidade">
                                <el-input v-model="linha.quantidade" @keyup.enter.native="incluir"
                                    placeholder="0"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="6" :sm="5" :md="3">
                            <el-form-item>
                                <el-button class="u-mt-20" type="primary" icon="el-icon-plus" @click="incluir" style="width:100%;">INCLUIR</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <div class="container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Produto</th>
                                <th style="width: 110px;" class="u-text-center">Unidade</th>
                                <th style="width: 130px;" class="u-text-center">Solicitado</th>
                                <th style="width: 130px;" class="u-text-center" v-if="mostrarRealizado">Realizado</th>
                                <th v-if="mostrarRealizado">Motivo do corte</th>
                                <th style="width: 70px;" class="u-text-center" v-if="!somenteLeitura">Ação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(it, i) in dados.itens" :key="i">
                                <td>{{ it.nome }}</td>
                                <td class="u-text-center">{{ it.unidade_medida }}</td>
                                <td class="u-text-center">{{ formataQtd(it.quantidade) }}</td>
                                <td class="u-text-center" v-if="mostrarRealizado">
                                    <!-- Zero é uma resposta do almoxarifado ("não enviei"), não ausência de dado. -->
                                    <span :class="classeRealizado(it)">{{ it.atendido === null ? '—' : formataQtd(it.atendido) }}</span>
                                </td>
                                <td v-if="mostrarRealizado">{{ it.motivo || '—' }}</td>
                                <td class="u-text-center" v-if="!somenteLeitura">
                                    <el-button size="mini" type="danger" plain icon="el-icon-delete"
                                        title="Excluir item" @click="dados.itens.splice(i, 1)"></el-button>
                                </td>
                            </tr>
                            <tr v-if="!dados.itens.length">
                                <td :colspan="colunasTabela" class="u-text-center" style="color:#909399; padding:12px;">
                                    Nenhum item incluído.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <el-row :gutter="10" class="u-mt-15">
                    <el-col :xs="24">
                        <el-input v-model="dados.observacao" :disabled="somenteLeitura" type="textarea" :rows="3"
                            maxlength="255" placeholder="Observação"></el-input>
                    </el-col>
                </el-row>

                <el-row :gutter="10" class="u-mt-15">
                    <el-col :xs="24" :sm="12">
                        <strong>Total de itens:</strong> {{ dados.itens.length }}
                    </el-col>
                    <el-col :xs="24" :sm="12" class="u-text-right">
                        <router-link to="/admin/almox-requisicao"><el-button class="u-mr-5">VOLTAR</el-button></router-link>
                        <el-button v-if="!somenteLeitura" type="primary" icon="el-icon-check" @click="salvar">SALVAR</el-button>
                    </el-col>
                </el-row>
            </c-panel>
        </div>
    </div>
</template>

<script>
/**
 * Requisição para o almoxarifado, no fluxo do sistema antigo: filtra-se o grupo
 * (ou "Todos"), busca-se o produto pelo nome, informa-se a quantidade e clica-se
 * em INCLUIR. Os itens vão se acumulando numa lista e a requisição inteira é
 * gravada de uma vez.
 *
 * O saldo do almoxarifado não aparece aqui: quem pede não precisa saber o que há
 * em estoque, e ver o número enviesaria o pedido.
 */
export default {
    data: () => ({
        carregando: false,
        edit: false,
        status: 1,
        numero: '',
        grupos: [],
        almoxarifado: null,
        produtos: [],
        buscandoProduto: false,
        // Linha de inclusão — não faz parte do que é gravado.
        linha: { grupo_id: '', produto_id: null, produto: null, quantidade: '' },
        dados: {
            instituicao_id: '',
            data_requisicao: '',
            observacao: '',
            itens: []
        }
    }),
    computed: {
        ehSmed () { return [4, 5, 6, 7, 8, 10].includes(Number(this.$store.state.user.tipo)) },
        operador () { return this.$store.state.user.name || '-' },
        nomeInstituicao () {
            const i = this.listaInstituicoes.find(x => x.id === this.dados.instituicao_id)
            return i ? i.nome : (this.$store.state.config.instituicao.nome || '-')
        },
        /**
         * A store guarda as instituições como objeto, não como array — o v-for
         * aceita os dois, mas filtrar exige normalizar antes.
         */
        listaInstituicoes () {
            const v = this.$store.state.instituicoes
            return Array.isArray(v) ? v : Object.values(v || {})
        },
        /** O almoxarifado não pede para si mesmo. */
        solicitantes () {
            return this.almoxarifado
                ? this.listaInstituicoes.filter(i => i.id !== this.almoxarifado.id)
                : this.listaInstituicoes
        },
        somenteLeitura () { return this.edit && this.status !== 1 },
        rotuloStatus () { return { 1: 'Aberta', 2: 'Atendida', 3: 'Cancelada' }[this.status] || '' },
        /** Só depois de atendida existe quantidade enviada para mostrar. */
        mostrarRealizado () { return this.edit && this.status === 2 },
        colunasTabela () {
            return 3 + (this.mostrarRealizado ? 2 : 0) + (this.somenteLeitura ? 0 : 1)
        },
        tituloTela () {
            if (!this.edit) return 'REQUISIÇÃO PARA O ALMOXARIFADO'
            return this.somenteLeitura ? 'REQUISIÇÃO (VISUALIZAÇÃO)' : 'EDITAR REQUISIÇÃO'
        }
    },
    mounted () {
        this.dados.data_requisicao = this.$moment().format('YYYY-MM-DD')

        if (!this.ehSmed && this.$store.state.config.instituicao) {
            this.dados.instituicao_id = this.$store.state.config.instituicao.id
        }

        this.carregarGrupos()
        this.carregarAlmoxarifado()

        if (this.$route.params.id) {
            this.edit = true
            this.carregar(this.$route.params.id)
        }
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },

        /* ----------------------------- listas ----------------------------- */
        /** Destino fixo de toda requisição — a instituição marcada como almoxarifado. */
        carregarAlmoxarifado () {
            this.$axios.get(`${this.baseUrl()}/api/almox-requisicao/almoxarifado`, this.$store.getters.getHeaderAuth)
                .then(r => {
                    this.almoxarifado = r.data || null
                    if (!this.almoxarifado) {
                        this.aviso('Nenhuma instituição está marcada como almoxarifado. Ajuste no cadastro de instituição.')
                    }
                })
                .catch(e => this.$store.commit('throwException', e))
        },
        carregarGrupos () {
            this.$axios.get(`${this.baseUrl()}/api/almox-grupo/getAll?situacao=true`, this.$store.getters.getHeaderAuth)
                .then(r => { this.grupos = r.data || [] }).catch(e => this.$store.commit('throwException', e))
        },
        /* --------------------------- busca -------------------------------- */
        /**
         * Com um grupo escolhido a lista abre inteira, como no legado; sem grupo,
         * são centenas de produtos e a busca por nome é obrigatória.
         */
        buscarProduto (termo) {
            const busca = (termo || '').trim()

            if (!this.linha.grupo_id && busca.length < 2) { this.produtos = []; return }

            this.buscandoProduto = true

            const params = {
                grupo_id: this.linha.grupo_id || null,
                busca,
                instituicao_id: this.almoxarifado ? this.almoxarifado.id : null,
                // Esconde os produtos que o gestor do almoxarifado tirou da requisição (só esta tela usa isto).
                somente_visiveis_requisicao: true,
                limite: 30
            }

            this.$axios.post(`${this.baseUrl()}/api/almox-produto/buscar`, params, this.$store.getters.getHeaderAuth)
                .then(r => { this.produtos = r.data || []; this.buscandoProduto = false })
                .catch(e => { this.buscandoProduto = false; this.$store.commit('throwException', e) })
        },
        trocarGrupo () {
            this.limparLinha()
            if (this.linha.grupo_id) this.buscarProduto('')
        },
        selecionarProduto (id) {
            this.linha.produto = this.produtos.find(p => p.id === id) || null
        },
        limparLinha () {
            this.linha.produto_id = null
            this.linha.produto = null
            this.linha.quantidade = ''
        },

        /* --------------------------- itens -------------------------------- */
        incluir () {
            const p = this.linha.produto

            if (!p) { this.aviso('Selecione o produto.'); return }

            const qtd = this.interpretaQtd(this.linha.quantidade)

            if (!(qtd > 0)) { this.aviso('Informe uma quantidade maior que zero.'); return }

            if (this.dados.itens.some(it => it.produto_id === p.id)) {
                this.aviso('Este produto já foi incluído na requisição.')
                return
            }

            this.dados.itens.push({
                produto_id: p.id,
                nome: p.nome,
                unidade_medida: p.unidade_medida,
                quantidade: qtd,
                atendido: null,
                motivo: ''
            })

            this.limparLinha()
        },
        /** Aceita 1, 1,5 e 1.5 — o operador digita do jeito que está acostumado. */
        interpretaQtd (valor) {
            const n = Number(String(valor === null || valor === undefined ? '' : valor).replace(',', '.'))
            return isNaN(n) ? 0 : n
        },
        /**
         * Sem a quantidade: quem faz a requisição não deve enxergar o estoque do
         * almoxarifado — o saldo é informação de quem atende, não de quem pede.
         */
        rotuloProduto (p) {
            const unidade = String(p.unidade_medida || 'UN').toLowerCase()
            return `${p.nome} - (${unidade})`
        },
        /**
         * Avisa que não há o produto sem dizer quanto existe — o saldo continua
         * sendo informação de quem atende.
         */
        semEstoque (p) { return !(Number(p.saldo) > 0) },
        formataQtd (valor) {
            const n = Number(valor) || 0
            return n % 1 === 0 ? String(n) : n.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })
        },
        /** Realça o que veio diferente do pedido: nada enviado, ou menos que o pedido. */
        classeRealizado (it) {
            if (it.atendido === null) return ''
            if (Number(it.atendido) === 0) return 'realizado-zero'
            return Number(it.atendido) < Number(it.quantidade) ? 'realizado-parcial' : ''
        },
        aviso (msg) { window.eventBus.$emit('alert', { msg, type: 'warning' }) },

        /* --------------------------- carga -------------------------------- */
        carregar (id) {
            this.carregando = true

            this.$axios.get(`${this.baseUrl()}/api/almox-requisicao/getById/${id}`, this.$store.getters.getHeaderAuth)
                .then(r => {
                    const reg = r.data || {}

                    this.status = reg.status
                    this.numero = reg.numero || ''

                    this.dados = {
                        instituicao_id: reg.instituicao_id,
                        data_requisicao: reg.data_requisicao ? this.$moment(reg.data_requisicao).format('YYYY-MM-DD') : '',
                        observacao: reg.observacao || '',
                        itens: (reg.itens || []).map(it => {
                            const prod = it.produto || {}
                            const unidade = prod.unidade_medida || 'UN'

                            return {
                                produto_id: it.produto_id,
                                nome: prod.nome || '(produto removido)',
                                unidade_medida: unidade,
                                quantidade: Number(it.quantidade),
                                atendido: it.quantidade_atendida === null || it.quantidade_atendida === undefined
                                    ? null
                                    : Number(it.quantidade_atendida),
                                motivo: it.motivo || ''
                            }
                        })
                    }

                    this.carregando = false
                })
                .catch(e => { this.carregando = false; this.$store.commit('throwException', e) })
        },

        /* --------------------------- salvar ------------------------------- */
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) { this.aviso('Preencha os campos obrigatórios.'); return }

                if (!this.dados.itens.length) { this.aviso('Inclua pelo menos um item na requisição.'); return }

                window.eventBus.$emit('loading', true)

                const payload = {
                    instituicao_id: this.dados.instituicao_id,
                    data_requisicao: this.dados.data_requisicao,
                    observacao: this.dados.observacao,
                    itens: this.dados.itens.map(it => ({ produto_id: it.produto_id, quantidade: it.quantidade }))
                }

                const url = this.edit
                    ? `${this.baseUrl()}/api/almox-requisicao/update/${this.$route.params.id}`
                    : `${this.baseUrl()}/api/almox-requisicao/store`

                this.$axios.post(url, payload, this.$store.getters.getHeaderAuth)
                    .then(r => {
                        window.eventBus.$emit('loading', false)

                        if (r.data && r.data.erro) { this.aviso(r.data.erro); return }

                        window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                        this.$router.push('/admin/almox-requisicao')
                    })
                    .catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        }
    }
}
</script>

<style scoped>
.sem-estoque {
    float: right;
    margin-left: 15px;
    color: #f56c6c;
    font-weight: bold;
    font-size: 12px;
}
.realizado-zero { color: #f56c6c; font-weight: bold; }
.realizado-parcial { color: #e6a23c; font-weight: bold; }
</style>
